/* eslint-disable react/prop-types */
import { Button, Dialog, DialogActions,  DialogTitle } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { PetsConsumer } from "../../../Contexts";
import API from "../../../helpers/apiHelpers";
import {useAppDispatch} from "../../../redux/store";
import {deleteAnimal} from "../../../redux/pets/pets.actions";
import {useHistory} from "react-router-dom";

interface Props {
	isOpen: boolean,
	onClose: React.Dispatch<React.SetStateAction<boolean>>,
	petId: number,
}

const RemovePet: FunctionComponent<Props> = ({isOpen, onClose, petId}) => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const handleConfirm = async (context) => {
        const deletedPet = await dispatch(deleteAnimal(petId));
        await context.setState({value: context.state.value.filter(item => item.id !== deletedPet.id)});
        onClose(false);
        history.push("/pets");
    };
    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            disableEnforceFocus
            aria-labelledby="upcoming-apointment-modify-title"
            aria-describedby="upcoming-apointment-modify-description"
        >
            <PetsConsumer>
                {
                    (context) => {
                        return (<>
                            <DialogTitle id="upcoming-apointment-modify-title">Are you sure you want to remove the pet from your pets list?</DialogTitle>
                            <DialogActions>
                                <Button onClick={() => {onClose(false);}} color="primary">
									Cancel
                                </Button>
                                <Button color="primary" autoFocus onClick={() => {handleConfirm(context);}}>
									Confirm
                                </Button>
                            </DialogActions>
                        </>);
                    }
                }
            </PetsConsumer>
        </Dialog>
    );
};

export default RemovePet;
